import { Button, SkeletonBar, TextPassage } from '@petsmart-ui/sparky';

import { useBopisDeliveryStatus } from '../../model';
import { BopisStoreStatusContent } from './BopisStoreStatusContent';
import { DeliveryDetailsContent } from './DeliveryDetailsContent';

export const BopisDeliveryDetails = () => {
    const {
        isLoading,
        storeDetails,
        isCurbsideAvailable,
        minimumCaseQty,
        isError,
        availableStock,
        openStoreDrawer,
        updateSelectedStore,
        isLivePetInStoreOnly,
    } = useBopisDeliveryStatus();

    if (isError) return null;

    async function handleStoreDrawer() {
        const selectedStoreId = await openStoreDrawer({
            drawerHeading: 'Pick up in store',
            toggleText: 'Only stores with item availability',
            className: 'pdp-page',
            filterFn: stores => stores.filter(store => store.attributes?.bopisEnabled),
        });
        if (selectedStoreId) {
            updateSelectedStore(selectedStoreId);
        }
    }

    return (
        <div data-testid="bopis-delivery-details" className="delivery-details__container">
            {isLivePetInStoreOnly && !!availableStock && (
                <TextPassage className="delivery-details__in-store-only sparky-u-theme-typography-body-lg-bold">
                    Available in-store only
                </TextPassage>
            )}
            <BopisStoreStatusContent
                availableStock={availableStock}
                minimumCaseQty={minimumCaseQty}
                isLoading={isLoading}
                storeDetails={storeDetails}
            />
            <div className="delivery-details__change-store">
                {isLoading ? (
                    <SkeletonBar
                        data-testid="change-store-skeleton"
                        className="delivery-details__change-store-skeleton"
                    />
                ) : (
                    <Button
                        type="button"
                        variant="link"
                        className="delivery-details__change-store-btn"
                        text={storeDetails ? 'Change store' : 'Find a nearby store'}
                        onClick={handleStoreDrawer}
                    />
                )}
            </div>
            {!isLivePetInStoreOnly && (
                <DeliveryDetailsContent
                    isLoading={isLoading}
                    isCurbsideAvailable={isCurbsideAvailable}
                    minimumCaseQty={minimumCaseQty}
                />
            )}
        </div>
    );
};
